import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SharedModule } from '../shared/shared.module'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap'
import { FiltersProgrammesComponent } from './filters-programmes.component'
import { RouterModule } from '@angular/router'

@NgModule({
  declarations: [FiltersProgrammesComponent],
  imports: [
    CommonModule,
    SharedModule,
    NgbCollapseModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
  ],
  exports: [FiltersProgrammesComponent],
})
export class FiltersProgrammesModule {}
